<template>
  <section class="contacts-section">
    <header-inner/>
    <wrapper :line-borders="false" :line-center="true" class=" page--bottom">
      <div class="main-title"><h1>UI</h1></div>
      <div class="main-title"><h2 class="text-center">Иконки SVG</h2></div>

      <p>Используется: class="icons_svg icon_1"</p>
      <ul class="ul__icons">
        <li class="icons_svg icon_1">icon_1 измерение_аудитории</li>
        <li class="icons_svg icon_2">icon_2 конверсия</li>
        <li class="icons_svg icon_3">icon_3 онлаи?н_продажа</li>
        <li class="icons_svg icon_4">icon_4 планирование рк</li>
        <li class="icons_svg icon_5">icon_5 прикрепить фаил</li>
        <li class="icons_svg icon_6">icon_6 ретаргетинг</li>
        <li class="icons_svg icon_7">icon_7 скачать</li>
        <li class="icons_svg icon_8">icon_8 таргетинг</li>

        <li class="icons_svg icon_9">icon_9 bb</li>
        <li class="icons_svg icon_10">icon_10 bb</li>

        <li class="icons_svg icon_11">icon_11 citybord</li>
        <li class="icons_svg icon_12">icon_12 citybord</li>

        <li class="icons_svg icon_13">icon_13 cityformat</li>
        <li class="icons_svg icon_14">icon_14 cityformat</li>
        <li class="icons_svg icon_15">icon_15 cityformat</li>

        <li class="icons_svg icon_16">icon_16 dbb</li>
        <li class="icons_svg icon_17">icon_17 dbb</li>
        <li class="icons_svg icon_18">icon_18 dbb</li>
        <li class="icons_svg icon_19">icon_19 dbb</li>
        <li class="icons_svg icon_20">icon_20 dbb</li>


        <li class="icons_svg icon_21">icon_21 dss</li>
        <li class="icons_svg icon_22">icon_22 dss</li>

        <li class="icons_svg icon_23">icon_23 pillar</li>
        <li class="icons_svg icon_24">icon_24 pillar</li>
        <li class="icons_svg icon_25">icon_25 pillar</li>
        <li class="icons_svg icon_26">icon_26 pillar</li>

        <li class="icons_svg icon_27">icon_27 ss</li>
        <li class="icons_svg icon_28">icon_28 ss</li>
        <li class="icons_svg icon_29">icon_29 ss</li>
        <li class="icons_svg icon_30">icon_30 ss</li>
        <li class="icons_svg icon_31">icon_31 ss</li>
        <li class="icons_svg icon_32">icon_32 ss</li>
        <li class="icons_svg icon_33">icon_33 ss</li>

        <li class="icons_svg icon_51">icon_51</li>
        <li class="icons_svg icon_52">icon_52</li>
        <li class="icons_svg icon_53">icon_53</li>
        <li class="icons_svg icon_54">icon_54</li>
        <li class="icons_svg icon_55">icon_55</li>
        <li class="icons_svg icon_56">icon_56</li>
        <li class="icons_svg icon_57">icon_57</li>
        <li class="icons_svg icon_58">icon_58</li>
        <li class="icons_svg icon_59">icon_59</li>
        <li class="icons_svg icon_60">icon_60</li>
        <li class="icons_svg icon_61">icon_61</li>
        <li class="icons_svg icon_62">icon_62</li>
        <li class="icons_svg icon_63">icon_63</li>
        <li class="icons_svg icon_64">icon_64</li>
        <li class="icons_svg icon_65">icon_65</li>
        <li class="icons_svg icon_66">icon_66</li>
        <li class="icons_svg icon_67">icon_67</li>
        <li class="icons_svg icon_68">icon_68</li>
        <li class="icons_svg icon_69">icon_69</li>
        <li class="icons_svg icon_70">icon_70</li>
        <li class="icons_svg icon_71">icon_71</li>
        <li class="icons_svg icon_72">icon_72</li>
        <li class="icons_svg icon_73">icon_73</li>
        <li class="icons_svg icon_74">icon_74</li>
      </ul>
      <div class="main-title"><h2 class="text-center">Иконки PNG</h2></div>
      <p>Используется: class="icons_png icon_1"</p>
      <ul class="ul__icons">
        <li class="icons_png icon_1">icon_1</li>
        <li class="icons_png icon_2">icon_2</li>
        <li class="icons_png icon_3">icon_3</li>
        <li class="icons_png icon_4">icon_4</li>
        <li class="icons_png icon_5">icon_5</li>
        <li class="icons_png icon_6">icon_6</li>

        <li class="icons_png icon_7">icon_7</li>
        <li class="icons_png icon_8">icon_8</li>
        <li class="icons_png icon_9">icon_9</li>
        <li class="icons_png icon_10">icon_10</li>

        <li class="icons_png icon_11">icon_11</li>
        <li class="icons_png icon_12">icon_12</li>
        <li class="icons_png icon_13">icon_13</li>
        <li class="icons_png icon_14">icon_14</li>
        <li class="icons_png icon_15">icon_15</li>

        <li class="icons_png icon_16">icon_16</li>
        <li class="icons_png icon_17">icon_17</li>
        <li class="icons_png icon_18">icon_18</li>
        <li class="icons_png icon_19">icon_19</li>
        <li class="icons_png icon_20">icon_20</li>

        <li class="icons_png icon_21">icon_21</li>
        <li class="icons_png icon_22">icon_22</li>
        <li class="icons_png icon_23">icon_23</li>
      </ul>
    </wrapper>
  </section>
</template>



<style lang="scss" scoped>

</style>

<script>
  import HeaderInner from '~/components/header/HeaderInner'
  export default {
    data() {
      return {}
    },
    name: "oferta",
    components: {
      HeaderInner,
    },
  }
</script>

<style lang="scss" scoped>
  .ul__icons {
    li {
      padding-bottom: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/ui.vue